export var DROP_IN_TYPE;
(function (DROP_IN_TYPE) {
    DROP_IN_TYPE[DROP_IN_TYPE["alert"] = 0] = "alert";
    DROP_IN_TYPE[DROP_IN_TYPE["prompt"] = 1] = "prompt";
    DROP_IN_TYPE[DROP_IN_TYPE["confirm"] = 2] = "confirm";
})(DROP_IN_TYPE || (DROP_IN_TYPE = {}));
var OverlayRenderer = (function () {
    function OverlayRenderer() {
    }
    return OverlayRenderer;
}());
export { OverlayRenderer };
//# sourceMappingURL=tokens.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-modal/esm/models/tokens.js
// module id = 185
// module chunks = 33